import { observer } from 'mobx-react';
import ModalStore from '../../Modal/Store';
import AddParticipantModal from '../AddParticipantModal';
import Body from './Body';
import Filters from './Filters';
import GroupPagination from './GroupPagination';
import GroupParticipantsStore from './GroupParticipantsStore/Store';
import {
  Ready,
  Sorting,
  UpdatingQuery,
  UpdatingSearchParameters,
} from './GroupParticipantsStore/Types';
import Table from '../Participants/Skeleton/Table';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
  modalStore: ModalStore;
  groupParticipantsState: Ready | UpdatingQuery | UpdatingSearchParameters | Sorting;
}

function GroupView({ groupParticipantsState, groupParticipantsStore, modalStore }: Props) {
  switch (groupParticipantsState.kind) {
    case 'ready':
      return (
        <>
          <div className="px-2.5 lg:px-12">
            <Filters groupParticipantsStore={groupParticipantsStore} />
            <Body
              groupParticipantsStore={groupParticipantsStore}
              modalStore={modalStore}
              groupParticipantsResource={groupParticipantsState.resource}
            />
            <GroupPagination
              state={groupParticipantsState}
              loadingMore={groupParticipantsStore.loadingMore}
            />
          </div>
          <AddParticipantModal
            groupParticipantsStore={groupParticipantsStore}
            groupParticipantsResource={groupParticipantsState.resource}
          />
        </>
      );
    case 'sorting':
    case 'updating-query':
    case 'updating-search-parameters':
      return (
        <>
          <div className="px-2.5 lg:px-12">
            <Filters groupParticipantsStore={groupParticipantsStore} />
            <Table tableColCount={7} checkBoxRequirement="not-required" tableRowCount={15} />
          </div>
        </>
      );
  }
}

export default observer(GroupView);
